// Characters: every character in a game and how many of each kind a game has, for a quick look
// during play. One page per game (/roles/bad-moon-rising; /roles is Trouble Brewing). Both come
// from the server's role catalog, so they match what the engine plays. In a room, the menu opens
// the same list in a sheet instead (CharactersSheet).
import { Link, useParams } from "react-router-dom";
import { CharacterList, CountTable, JumpChips, kindJumps } from "../components/Characters";
import { GameSwitch } from "../components/GameSwitch";
import { useScript } from "../hooks/useScript";
import { howToPlayPath, rolesPath, scriptIdFromSlug } from "../lib/scripts";

export function RolesScreen() {
  const { script: slug } = useParams<{ script?: string }>();
  const scriptId = scriptIdFromSlug(slug);
  const script = useScript(scriptId);
  return (
    <main className="screen guide" data-screen="roles">
      <header className="row-between" style={{ minHeight: 44 }}>
        <Link to="/" className="icon-btn" style={{ marginLeft: -8 }}>
          ← Home
        </Link>
        <Link to={howToPlayPath(scriptId)} className="icon-btn" style={{ marginRight: -8 }}>
          How to play
        </Link>
      </header>

      <div className="stack-sm">
        <h1>Characters</h1>
        <GameSwitch current={scriptId} path={rolesPath} />
        <p className="muted">
          {typeof script === "object"
            ? `Every character in ${script.name}. Only some of them are in each game.`
            : "Every character that can be in a game. Only some of them are in each one."}
        </p>
      </div>

      {script === "loading" && <p className="small muted">Loading the characters…</p>}
      {script === "error" && (
        <p className="error-text">
          Could not load the characters. Check your connection and reload the page.
        </p>
      )}
      {typeof script === "object" && (
        <>
          <JumpChips items={[...kindJumps(script.roles), { id: "counts", label: "How many" }]} />
          <CharacterList roles={script.roles} />
          <section id="counts" className="guide-section stack">
            <h2>How many of each</h2>
            <p className="small muted">
              Every game has one Demon. How many of the others depends on how many are playing.
            </p>
            <CountTable counts={script.counts} />
          </section>
        </>
      )}
    </main>
  );
}
